import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useLayoutEffect(() => {
        // disable browser auto scroll restoration so we can control it
        if ('scrollRestoration' in window.history) {
            const prev = window.history.scrollRestoration;
            window.history.scrollRestoration = 'manual';
            return () => {
                window.history.scrollRestoration = prev;
            };
        }
    }, []);

    useLayoutEffect(() => {
        // If there's a hash (anchor) we should let the browser handle it instead of forcing top.
        if (hash && hash.length > 0) {
            return;
        }

        // Temporarily disable smooth scroll to avoid visible animation
        const html = document.documentElement;
        const prevScrollBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';

        // Synchronously set scroll to top before paint to avoid a visible jump
        window.scrollTo(0, 0);

        // Restore scroll behavior next frame
        requestAnimationFrame(() => {
            html.style.scrollBehavior = prevScrollBehavior || '';
        });
    }, [pathname, hash]);

    return null;
}
